type Props = {
  min?: number | null
  max?: number | null
  total: number
}
export const getDisabledFlagsByMinAndMax = ({ min, max, total = 0 }: Props) => {
  const disableMin = min && total < min
  const disableMax = max && total > max

  let greaterThanMax = false
  if (Number(min) > Number(max)) {
    greaterThanMax = true
  }

  return { disableMin, disableMax, greaterThanMax }
}
